
import { computed, defineComponent, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import moment from "moment";
import Documents from "@/views/pages/application/view/tabs/Document.vue";
import ViewActions from "@/views/pages/application/view/tabs/ViewActions.vue";
import NoteSection from "@/components/sections/NoteSection.vue";

export default defineComponent({
  name: "kt-vertical-wizard",
  methods: {
    moment(date) {
      return moment(date).format("MMM DD, YYYY");
    },
  },
  components: {
    Documents,
    ViewActions,
    NoteSection,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const modalNoteType = "Research Activities";

    const currentResearch = computed(() => {
      return store.getters.currentResearch;
    });

    const currentApplication = computed(() => {
      return store.getters.currentApplication !== null
        ? store.getters.currentApplication.data
        : {};
    });

    const currentIrbReviewer = computed(() => {
      return store.getters.currentIrbReviewer;
    });

    const currentIrbReviewNote = computed(() => {
      return store.getters.currentReviewNoteEdit;
    });

    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    const IsIrbChair = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("irbchair") !== -1) {
        return "Yes";
      }
      return "No";
    });

    const IsIrbMember = computed(() => {
      if (currentUser.value?.userRoles?.indexOf("irbmember") !== -1) {
        return "Yes";
      }
      return "No";
    });

    onMounted(() => {
      store.dispatch(Actions.GET_IRB_APPLICATION_RESEARCH, route.params.id);
      setCurrentPageBreadcrumbs("Vertical", ["Pages", "Wizards"]);
    });

    watch(
      () => route.params.id,
      async () => {
        await store.dispatch(
          Actions.GET_IRB_APPLICATION_RESEARCH,
          route.params.id
        );
      }
    );

    return {
      currentResearch,
      currentApplication,
      currentIrbReviewNote,
      currentIrbReviewer,
      currentUser,
      IsIrbMember,
      IsIrbChair,
      Documents,
      modalNoteType,
    };
  },
});
